module.exports = __webpack_public_path__ + "static/assets/28e71f30018da86496fe7c505cc228d5.gif";